import { Injectable } from "@angular/core";
import { BaseService } from "../shared/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class VaxContactusService {

  constructor(private readonly baseService: BaseService) { }

  submitContactFormService(params) {
    return this.baseService.post('contactUs/submitted', params);
  }
}
